<script>

export default {
  props: {
    percentual: { type: Number, required: true },
    altura: { type: Number, required: true }
  },
  data: () => ({
    temperatura: '',
    showPointer: false
  }),
  methods: {
    cria: async function () {
      let canvas = document.getElementById('miCanvas')
      let contexto = canvas.getContext('2d')
      let cores = ['#ff1919', '#f7e222', '#ace227', '#6ad72c']

      function radianos (graus) {
        return graus * Math.PI / 180
      }

      let qtd = 4
      let y = this.altura
      let radio = this.altura
      let x = this.altura

      contexto.fillStyle = '#fff'
      contexto.strokeStyle = '#fff'
      contexto.lineWidth = 0

      contexto.beginPath()
      contexto.arc(x, y, radio, 0, radianos(180))
      contexto.fill()
      contexto.closePath()

      async function geraPartes () {
        for (let i = 0; i < qtd; i++) {
          contexto.fillStyle = cores[i]
          contexto.beginPath()
          contexto.moveTo(x, y)
          var fraccion = 180 / qtd
          var graus = fraccion * (i + 180)
          contexto.arc(x, y, radio, radianos(graus), radianos(graus + fraccion))
          contexto.fill()
          contexto.stroke()
          contexto.closePath()
        }
      }
      await geraPartes()
      return true
    },
    trataPercentual: function () {
      this.showPointer = false
      if (this.percentual < 5) this.temperatura = 'vermelho'
      else if (this.percentual < 10) this.temperatura = 'amarelo'
      else if (this.percentual < 15) this.temperatura = 'verdeClaro'
      else if (this.percentual >= 15) this.temperatura = 'verdeEscuro'
      this.showPointer = true
    }
  },
  watch: {
    'percentual': async function () {
      this.trataPercentual()
    }
  },
  async mounted () {
    await this.cria()
    this.trataPercentual()
  }
}
</script>
<template>
  <div class="conteiner" :width="altura * 2" :class="{ menor : altura < 50 }">
    <canvas id="miCanvas" :width="altura * 2" :height="altura"> </canvas>
    <div class="pointer" :class="temperatura" v-if="showPointer"></div>
  </div>
</template>
<style scoped>
  .conteiner {
    position: relative;
    float: left;
    overflow: hidden;
  }
  canvas {
    z-index: 1;
  }
  .pointer {
    border-top-left-radius: 35%;
    border-top-right-radius: 35%;
    width: 3px;
    background: #000;
    height: 75%;
    position: absolute;
    top: 52%;
    left: 29%;
    transform: rotate(-90deg);
  }
  .pointer.vermelho {
    transform: rotate(-72deg);
    top: 43%;
    left: 30%;
  }
  .pointer.amarelo {
    transform: rotate(-23deg);
    top: 21%;
    left: 40%;
  }
  .pointer.verdeClaro {
    transform: rotate(23deg);
    top: 26%;
    left: 57%;
  }
  .pointer.verdeEscuro {
    transform: rotate(72deg);
    top: 45%;
    left: 67%;
  }
  .conteiner.menor .pointer {
    border-radius: 35%;
    width: 2.5px;
  }
</style>



// WEBPACK FOOTER //
// termometro.vue?3c24190e